import type { PermissionService } from "../PermissionService";
import type { ScopedViewPermissionAttributes } from "./AbstractScopedViewVoter";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { AbstractScopedViewVoter } from "./AbstractScopedViewVoter";

export class TaskViewVoter extends AbstractScopedViewVoter {
  protected readonly attrs: ScopedViewPermissionAttributes = {
    readAny: PermissionAttributesEnum.GlobalOperationTaskviewReadany,
    createAny: PermissionAttributesEnum.GlobalOperationTaskviewCreateany,
    updateAny: PermissionAttributesEnum.GlobalOperationTaskviewUpdateany,
    deleteAny: PermissionAttributesEnum.GlobalOperationTaskviewDeleteany,
    read: PermissionAttributesEnum.ContextOperationTaskviewRead,
    create: PermissionAttributesEnum.ContextOperationTaskviewCreate,
    update: PermissionAttributesEnum.ContextOperationTaskviewUpdate,
    delete: PermissionAttributesEnum.ContextOperationTaskviewDelete,
    readCollectionViaClient: PermissionAttributesEnum.ContextOperationTaskviewReadcollectionviaclient,
    readCollectionViaLocation: PermissionAttributesEnum.ContextOperationTaskviewReadcollectionvialocation,
    readCollectionViaPtg: PermissionAttributesEnum.ContextOperationTaskviewReadcollectionviaptg,
    readCollectionGlobal: PermissionAttributesEnum.ContextOperationTaskviewReadcollectionglobal,
    readEffective: PermissionAttributesEnum.ContextOperationTaskviewReadeffective,
    readDefinitionSchema: PermissionAttributesEnum.ContextOperationTaskviewReaddefinitionschema,
  };

  constructor(permissionService: PermissionService) {
    super(permissionService);
  }
}
